export default __webpack_public_path__ + "static/media/arsenal.7c04ebc5.png";